<template>
  <div v-if="$slots.default" class="flex-none">
    <slot />
  </div>
  <div
    v-else-if="title || showClose"
    class="pt-safe bg-n-0 dark:bg-n-900 sm:dark:bg-n-800 sm:bg-transparent sm:pt-2"
  >
    <div
      class="h-14 flex items-center justify-between px-6"
      :class="[!title && (showBack || showClose) ? 'absolute w-full' : '']"
    >
      <div class="font-heading font-bold text-xl flex items-center gap-2">
        <l-icon v-if="showBack" name="bracket-left" class="cursor-pointer" @click="handleBack" />
        {{ title }}
      </div>
      <div v-if="!showBack && showClose" class="cursor-pointer" @click="handleClose">
        <l-icon name="close" size="small" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'

import LIcon from '../LIcon.vue'

interface Props {
  title?: string
  showBack?: boolean
  showClose?: boolean
}

withDefaults(defineProps<Props>(), {
  title: '',
  showBack: false,
  showClose: true
})

const emit = defineEmits<{
  (e: 'back'): void
}>()

const modalContext = inject<any>('modalContext', null)

function handleClose() {
  modalContext?.close?.()
}

function handleBack() {
  emit('back')
}
</script>
